/** The maximum number of sort levels the task grid supports. */ export const MAX_SORT_LEVELS = 3;
/**
 * Column name/id enum
 */ export var TaskGridColumnId = /*#__PURE__*/ function(TaskGridColumnId) {
    /** Column name for effort field */ TaskGridColumnId["Effort"] = "effort";
    /** Column name for percent complete field */ TaskGridColumnId["PercentComplete"] = "percentComplete";
    /** Column name for assignments field */ TaskGridColumnId["Assignments"] = "assignments";
    /** Column name for title field */ TaskGridColumnId["Title"] = "title";
    /** Column name for bucket field */ TaskGridColumnId["Bucket"] = "bucketId";
    /** Column name for the start date column */ TaskGridColumnId["StartDate"] = "startDate";
    /** Column name for the due date column */ TaskGridColumnId["DueDate"] = "dueDate";
    /** Column name for the finish date column */ TaskGridColumnId["FinishDate"] = "finishDate";
    /** Column name for the priority column */ TaskGridColumnId["Priority"] = "priority";
    /** Column name for mark task complete column */ TaskGridColumnId["MarkTaskAsCompleteColumnName"] = "markTaskAsComplete";
    /** Column name for the 'add column' column */ TaskGridColumnId["AddColumnColumnName"] = "addColumn";
    /** Column name for the plan column */ TaskGridColumnId["Plan"] = "plan";
    /** Column name for Quick look column */ TaskGridColumnId["QuickLook"] = "quickLook";
    /** Column name for the labels column */ TaskGridColumnId["Labels"] = "labels";
    /** Column name for the status column */ TaskGridColumnId["Status"] = "status";
    /** Column name for the predecessor column (tasks this task depends on) */ TaskGridColumnId["Predecessor"] = "predecessor";
    /** Column name for the successor column (tasks that depend on this task) */ TaskGridColumnId["Successor"] = "successor";
    /** Column name for the goals column (goals the task is associated with) */ TaskGridColumnId["Goal"] = "goal";
    return TaskGridColumnId;
}({});
/** Prefix for custom field column IDs to avoid collision with TaskGridColumnId values */ export const CUSTOM_FIELD_COLUMN_PREFIX = "cf_";
/**
 * Names for the grid view
 * Note: currently only includes user grid views for My Day/My Tasks
 */ export var GridViewName = /*#__PURE__*/ function(GridViewName) {
    GridViewName["MyDayGridView"] = "MyDayGridView";
    GridViewName["PlannerMyDayGridView"] = "PlannerMyDayGridView";
    GridViewName["AllUserTasksGridView"] = "AllUserTasksGridView";
    GridViewName["PlannerAllUserTasksGridView"] = "PlannerAllUserTasksGridView";
    GridViewName["AssignedToUserGridView"] = "AssignedToUserGridView";
    GridViewName["PlannerAssignedToUserGridView"] = "PlannerAssignedToUserGridView";
    GridViewName["PrivateTasksGridView"] = "PrivateTasksGridView";
    GridViewName["MyTasksBasicPlanTasksGridView"] = "MyTasksBasicPlanTasksGridView";
    GridViewName["BasicPlanTasksGridView"] = "BasicPlanTasksGridView";
    GridViewName["PlanTasksGridView"] = "PlanTasksGridView";
    GridViewName["MyTasksPlanTasksGridView"] = "MyTasksPlanTasksGridView";
    GridViewName["FlaggedEmailsGridView"] = "FlaggedEmailsGridView";
    GridViewName["GoalTasksGridView"] = "GoalTasksGridView";
    GridViewName["TimelineGridView"] = "TimelineGridView";
    return GridViewName;
}({});
/**
 * Icons for add contextual menu
 */ export var AddColumnIcons = /*#__PURE__*/ function(AddColumnIcons) {
    AddColumnIcons["TextField"] = "TextField";
    return AddColumnIcons;
}({});
/**
 * Columns that support sorting
 */ export const SortableColumns = [
    "title",
    "priority",
    "dueDate",
    "startDate",
    "finishDate",
    "status",
    "bucketId",
    "plan",
    "assignments",
    "goal",
    "percentComplete",
    "effort"
];
/**
 *
 * Default column order for user views with Plan column
 */ export const DefaultUserTaskGridColumnOrderWithPlan = [
    "markTaskAsComplete",
    "title",
    "plan",
    "dueDate",
    "priority",
    "percentComplete",
    "quickLook"
];
/**
 *
 * Default column order for user views with Plan column
 */ export const DefaultPlannerUserTaskGridColumnOrderWithPlan = [
    "markTaskAsComplete",
    "title",
    "plan",
    "dueDate",
    "priority",
    "status",
    "quickLook"
];
/**
 * Default column order for user views without Plan column
 */ export const DefaultUserTaskGridColumnOrderWithoutPlan = [
    "markTaskAsComplete",
    "title",
    "dueDate",
    "priority",
    "percentComplete",
    "quickLook"
];
/**
 * Default column order for user views without Plan column
 */ export const DefaultPlannerUserTaskGridColumnOrderWithoutPlan = [
    "markTaskAsComplete",
    "title",
    "dueDate",
    "priority",
    "status",
    "quickLook"
];
/**
 * Default column order for Basic plans
 */ export const DefaultBasicPlanTaskGridColumnOrder = [
    "markTaskAsComplete",
    "title",
    "assignments",
    "startDate",
    "finishDate",
    "dueDate",
    "bucketId",
    "percentComplete",
    "priority",
    "labels",
    "quickLook"
];
/**
 * Default column order for Plan tasks
 */ export const DefaultPlanTaskGridColumnOrder = [
    "markTaskAsComplete",
    "title",
    "assignments",
    "startDate",
    "finishDate",
    "dueDate",
    "bucketId",
    "status",
    "priority",
    "labels",
    "goal",
    "quickLook"
];
/**
 * Default column order for Timeline/Gantt side panel
 */ export const DefaultTimelineTaskGridColumnOrder = [
    "markTaskAsComplete",
    "title",
    "assignments"
];
/**
 * Default column order for Goal tasks
 */ export const DefaultGoalTaskGridColumnOrder = [
    "markTaskAsComplete",
    "title",
    "assignments",
    "status",
    "dueDate",
    "priority"
];
/**
 * Mapping of grid view names to their respective column orders
 */ export const DefaultTaskGridColumnOrder = {
    ["MyDayGridView"]: DefaultUserTaskGridColumnOrderWithPlan,
    ["PlannerMyDayGridView"]: DefaultPlannerUserTaskGridColumnOrderWithPlan,
    ["AllUserTasksGridView"]: DefaultUserTaskGridColumnOrderWithPlan,
    ["PlannerAllUserTasksGridView"]: DefaultPlannerUserTaskGridColumnOrderWithPlan,
    ["AssignedToUserGridView"]: DefaultUserTaskGridColumnOrderWithPlan,
    ["PlannerAssignedToUserGridView"]: DefaultPlannerUserTaskGridColumnOrderWithPlan,
    ["PrivateTasksGridView"]: DefaultPlannerUserTaskGridColumnOrderWithoutPlan,
    ["MyTasksBasicPlanTasksGridView"]: DefaultUserTaskGridColumnOrderWithoutPlan,
    ["BasicPlanTasksGridView"]: DefaultBasicPlanTaskGridColumnOrder,
    ["PlanTasksGridView"]: DefaultPlanTaskGridColumnOrder,
    ["MyTasksPlanTasksGridView"]: DefaultPlannerUserTaskGridColumnOrderWithoutPlan,
    ["FlaggedEmailsGridView"]: DefaultPlannerUserTaskGridColumnOrderWithoutPlan,
    ["GoalTasksGridView"]: DefaultGoalTaskGridColumnOrder,
    ["TimelineGridView"]: DefaultTimelineTaskGridColumnOrder
};
// The dimensions for the grid
/** Height for the header row */ export const GridHeaderHeight = 40;
/** Width for the row header column */ export const GridRowHeaderWidth = 32;
/** Height for the row */ export const GridRowHeight = 40;
/** Column width for the 'add column' column */ export const GridAddColumnWidth = 164;
/** Column width for 'Mark task as complete' cell */ export const GridMarkTaskAsCompleteColumnWidth = 40;
/** Default width for columns */ export const GridDefaultColumnWidth = 144;
/** Column width for 'Assigned to' column */ export const GridAssignedToColumnWidth = 180;
/** Column width for 'Plan' column */ export const GridPlanColumnWidth = 230;
/** Column width for the 'Title' column */ export const GridTitleColumnWidth = 378;
/** Column width for the 'Title' column in goals grid */ export const GridGoalsTitleColumnWidth = 700;
/** Undefined column width */ export const GridUndefinedColumnWidth = 0;
/** Column width for the 'Labels' column */ export const GridLabelsColumnWidth = 200;
/** Quicklook column width */ export const GridQuicklookColumnWidth = 180;
/** Column width for the 'Bucket' column */ export const GridBucketColumnWidth = 150;
/** Column width for the 'Due date' column */ export const GridDueDateColumnWidth = 150;
/** Column width for the 'Status' column */ export const GridStatusColumnWidth = 150;
/** Column width for the 'Priority' column */ export const GridPriorityColumnWidth = 150;
/** Column width for the 'Percent complete' column */ export const GridPercentCompleteColumnWidth = 150;
/** Column width for the 'Effort' column */ export const GridEffortColumnWidth = 150;
/** Column width for the 'Start date' column */ export const GridStartDateColumnWidth = 150;
/** Column width for the 'Finish date' column */ export const GridFinishDateColumnWidth = 150;
/** Column width for dependency columns (Predecessor / Successor) */ export const GridDependencyColumnWidth = 180;
/** Column width for the 'Goal' column */ export const GridGoalColumnWidth = 180;
/** Default column width for custom field columns */ export const GridCustomFieldColumnWidth = 150;
/** Minimum column width for custom field columns */ export const GridCustomFieldColumnMinWidth = 80;
/** The My Day indicator icon width */ export const MyDayIndicatorWidth = 16;
/** The task note indicator icon width */ export const NotesIndicatorWidth = 16;
/** The attachment indicator icon width */ export const AttachmentsIndicatorWidth = 25;
/** The checklist indicator icon width */ export const ChecklistIndicatorWidth = 40;
/** The task conversation indicator icon height */ export const ConversationsIndicatorHeight = 17;
/** The task conversation indicator icon width */ export const ConversationsIndicatorWidth = 16;
/** The app powered indicator icon width */ export const AppPoweredIndicatorWidth = 16;
// Constants to be used in Grid cells
/** Default value for a cell in the grid */ export const GridCellDefaultValue = "";
/** The left padding for selection column */ export const GridCellToggleTaskCompletionColumnLeftPadding = "0px";
/** The right padding for selection column */ export const GridCellToggleTaskCompletionColumnRightPadding = "0px";
/** The top padding for selection column */ export const GridCellToggleTaskCompletionColumnTopPadding = "13px";
/** The bottom padding for selection column */ export const GridCellToggleTaskCompletionColumnBottomPadding = "11px";
// Constants to be used in Task Grid context menu
export const GridContextMenuTaskDetails = "taskDetails";
export const GridContextMenuCopyLinkToTask = "copyLinkToTask";
export const GridContextMenuDeleteTask = "deleteTask";
export const GridContextMenuMarkTaskAsComplete = "markTaskAsComplete";
export const GridContextMenuReactivateTask = "markTaskAsIncomplete";
export const GridContextMenuAddToMyDay = "addToMyDay";
export const GridContextMenuRemoveFromMyDay = "removeFromMyDay";
export const GridContextMenuCopyTask = "copyTask";
export const GridContextMenuMoveTask = "moveTask";
export const GridContextMenuPriority = "priority";
export const GridContextMenuDueDate = "dueDate";
export const GridContextMenuProgress = "progress";
export const GridContextMenuStartDate = "startDate";
export const GridContextMenuAssignments = "assignments";
export const GridContextMenuConnectToGoal = "connectToGoal";
export const GridContextMenuConnectToGoalSubmenu = "connectToGoal_submenu";
export const GridContextMenuConnectToPlan = "connectToPlan";
export const GridContextMenuCreatePlanFromTask = "createPlanFromTask";
export const GridContextMenuLinkToExistingPlan = "linkToExistingPlan";
export const GridContextMenuOpenConnectedPlan = "openConnectedPlan";
export const GridContextMenuDisconnectPlan = "disconnectPlan";
// Constants to be used in Task Grid column context menu
export const GridContextMenuHideColumn = "hideColumn";
export const GridContextMenuTitleColumn = "titleColumn";
export const GridContextMenuCreatePlan = "createPlanColumn";
export const GridContextMenuDueDateColumn = "dueDateColumn";
export const GridContextMenuPriorityColumn = "priorityColumn";
export const GridContextMenuProgressColumn = "progressColumn";
export const GridContextMenuQuickLookColumn = "quickLookColumn";
export const GridContextMenuAssignmentsColumn = "assignmentsColumn";
export const GridContextMenuStartDateColumn = "startDateColumn";
export const GridContextMenuBucketColumn = "bucketColumn";
export const GridContextMenuLabelsColumn = "labelsColumn";
// Icons to be used in Task grid column
/** The icon name for MyDay */ export const MyDayIconName = "plannerMyDayRegularSmall";
/** The icon name for notes */ export const NotesIconName = "QuickNote";
/** The icon name for notes */ export const AttachmentIconName = "Attach";
/** The icon name of conversations */ export const ConversationsIconName = "SkypeMessage";
/** The icon name for the checklist in a task */ export const ChecklistIconName = "Completed";
/** The icon name for the app powered task */ export const AppPoweredIconName = "plannerAppsSmall";
/**
 * Mapping of grid column IDs to actual task property names
 * Used to map column identifiers to their corresponding ITask property keys
 */ export const GridColumnToTaskPropertyMap = {
    ["title"]: "displayName",
    ["dueDate"]: "dueDateTime",
    ["startDate"]: "startDateTime",
    ["finishDate"]: "finishDateTime",
    ["priority"]: "priority",
    ["status"]: "status",
    ["assignments"]: "userAssignments",
    ["plan"]: "planId",
    ["bucketId"]: "bucketId",
    ["goal"]: "goalIds",
    ["percentComplete"]: "percentComplete",
    ["effort"]: "effort"
};
/** Maximum number of tasks that can be pasted or moved in a single operation. */ export const MAX_PASTE_AND_MOVE_TASK_COUNT = 20;
/** Maximum number of custom field columns rendered inline in the bulk-edit context menu before overflow */ export const MAX_INLINE_CUSTOM_FIELD_COLUMNS = 3;
/** Synthetic column ID used by the canvas grid's "add column" button */ export const CanvasGridAddColumnId = "__add_column__";
/** Column IDs excluded from clipboard HTML */ export const ClipboardExcludedColumns = new Set([
    "addColumn",
    CanvasGridAddColumnId,
    "markTaskAsComplete",
    "quickLook"
]);
export const TaskGridColumnDefaultWidths = {
    ["addColumn"]: GridAddColumnWidth,
    ["assignments"]: GridAssignedToColumnWidth,
    ["bucketId"]: GridBucketColumnWidth,
    ["dueDate"]: GridDueDateColumnWidth,
    ["labels"]: GridLabelsColumnWidth,
    ["markTaskAsComplete"]: GridMarkTaskAsCompleteColumnWidth,
    ["percentComplete"]: GridPercentCompleteColumnWidth,
    ["effort"]: GridEffortColumnWidth,
    ["status"]: GridStatusColumnWidth,
    ["plan"]: GridPlanColumnWidth,
    ["priority"]: GridPriorityColumnWidth,
    ["quickLook"]: GridQuicklookColumnWidth,
    ["startDate"]: GridStartDateColumnWidth,
    ["finishDate"]: GridFinishDateColumnWidth,
    ["title"]: GridTitleColumnWidth,
    ["predecessor"]: GridDependencyColumnWidth,
    ["successor"]: GridDependencyColumnWidth,
    ["goal"]: GridGoalColumnWidth
};
/**
 * Number of placeholder rows rendered by the canvas grid loading shimmer.
 * Shown while critical data is loading in place of a blank screen.
 */ export const NumberOfLoadingTasksShimmerRowsInCanvasGrid = 8;
/**
 * Number of placeholder rows rendered by the task grid loading shimmer.
 * Shown while critical data is loading in place of a blank screen.
 */ export const NumberOfGridLoadingRows = 7;
